import React, { createContext, useState, useContext, ReactNode, useCallback, useMemo } from "react";
import { INewVendorFormData, IAsessProductFormData, IPrePanelInformationFormData, IPannelReviewFormData, IDocumentApprovalFormData, IVendorInformationFormData, IProductInformationFormData, INewProductFormData, IStorageFormData, IPackagingFormData, Group, IVendorAssessmentFormData, IIngredientDetailsFormData, IVendorContactInformationFormData, IManufacturingFacilityInformationFormData, IPurchaseOrderInformationFormData, ITastingPanelFormData, IdeaData, IShoppingListData, SelectedIdea, Statuses, ButtonToVisible, IRequiredDocumentData, IPhotosofItemInRetailPackaging, VendorAssessmentButtonToVisible, vendorStatuses, ICertificatesDocumentsVendorInfoFormData, IPackProductFormData, VendorPrePanelInformationFormData, IAddNewVendorUserData, IVendorSetupFormData,  IOfficialProductSetupFormData, vendorStatusesObj, IPrePanelGetData, BusinessQuestionnairesItem, PrePanelButtonToVisible, BusinessReviewButtonToVisible, TastingPanelVendorStatusesObj, TastingPanelButtonToVisible,IAddNewVendorUserFormData, VendorUserInformationFormErrors, VendorSiteDetailsFormData, VendorSiteDetailsFormErrors, FoodSafetyQuestionnaireFormData, IVendorUser, ISendWelcomeEmailFormData, IVendorSiteDetailsFormData, VendorSiteListData, IVendorAuditDetailsFormData, IVendorAuditQuestionnairesFormData, VendorAuditData, APComplianceDocumentsButtonToVisible, APMainDetailsButtonToVisible, APPackagingButtonToVisible, APRecipeButtonToVisible, APRawMaterialsButtonToVisible, APAllergensButtonToVisible, APNutritionButtonToVisible, APNutritionDeclarationButtonToVisible, APStorageButtonToVisible, VendorContactData, IVendorAuditApiResponse, IMVADocumentResponse } from "@/context/data.types";
import { IMainDetailsForm, IProductSpecificationInformationForm, IProductRelatedInformationForm, IVendorRelatedInformation, IVendorFacilityInformation } from "@/types/active-projects/MainDetails.types";

import { PannelReviewFormData, AsessProductFormData, PanelProductInformationFormData, DocumentApprovalFormData, VendorInformationFormData, NewVendorDetailsForm, StorageFormData, PackagingFormData, NewProductInformationFormData, VendorAssessmentFormData, IngredientDetailsFormData, VendorContactInformationFormData, DefaultManufacturingFacilityInformationFormsData, PurchaseOrderInformationFormData, TastingPanelFormData, ProductIdeaData, SelectedIdeaInfo, DefaultStatusesOfProduct, DefaultButtonVisibility, DefaultVendorAssessmentButtonVisibility, CertificatesDocumentsVendorInfoFormData, packProductFormData, vendorPrePanelInformationFormData, addNewVendorUserData, VendorSetupFormData, officialProductSetupFormData, defaultVendorStatusesObj, DefaultPrePanelButtonVisibility, DefaultBusinessReviewButtonVisibility, defaultTastigPanelVendorStatusObj, DefaultTastingPanelButtonVisibility, DefaultAddNewVendorFormsData, DefaultVendorSiteDetailsFormsData, foodSafetyQuestionnaireFormData, DefaultRequiredDocumentData, DefaultMVADocumentResponse, defaultSendWelcomeEmailFormData , vendorSitesFormData, InitialAddNewVendorFormsData, VendorAuditDetailsFormData, DefaultAPComplianceDocumentsButtonVisibility, DefaultAPMainDetailsButtonVisibility, DefaultAPPackagingButtonVisibility, DefaultAPRecipeButtonVisibility, DefaultAPRawMaterialsButtonVisibility, DefaultAPAllergensButtonVisibility, DefaultAPNutritionButtonVisibility, DefaultAPNutritionDeclarationButtonVisibility, DefaultAPStorageButtonVisibility, DefaultVendorContactData } from "@/context/data";
import { MainDetailsFormInitial, ProductSpecificationInformationFormInitial, ProductRelatedInformationFormInitial, VendorRelatedInformationInitial, VendorFacilityInformationInitial } from "@/static/initial/active-projects/MainDetails";

import { DefaultPrepanelInformationFormData } from "@/static/initial/PrePanelInformation";
import {
  VendorInformationFormErrors,
  productInformationFormErrors,
  VendorAssessmentFormErrors,
  IngredientDetailsFormErrors,
  VendorContactFormErrors,
  ManufacturingFacilityInformationFormErrors
} from "@/context/data.types";
import { IPrePanelInformation, IPrePanelInformationErrors, PrepanelResponseData } from "@/types/PrePanelInformation.types";
import { CompetitorInformationInitial, GeneralInformationInitial, PackageAndBrandingInitial, ResponsibleUsersInitial, RetailSalesAndVolumeInitial, VoteResultsInitial } from "@/static/initial/TastingPanel";
import { NutritionFormInitial } from "@/static/initial/Nutrition";
import { ICompetitorInformation, IGeneralInformation, IPackageAndBranding, IResponsibleUsers, IRetailSalesAndVolume, IVoteResults, nfpType } from "@/types/TastingPanel.types";
import { INutritionForm, GetNutritionSectionsResponse, INutritionSectionTrackingItem } from "@/types/Nutrition.types";
import { GetStorageSectionsResponse, IStorageSectionTrackingItem } from "@/types/Storage.types";
import { fileType } from "@/types/Common.types";
import { IVendorCompanyInformationFormData } from "@/types/VendorManagement.types";
import { DefaultVendorCompanyInformationFormData, initializeVendorAuditDetailsForm } from "@/static/initial/VendorManagement";
import type { ShoplistOnloadResponse } from "@/types/ProductService.types";
import type { BusinessReviewFormErrors } from "@/types/BusinessReview.types";

// Define the combined context props
interface FormContextProps {
  pannelReviewForm: IPannelReviewFormData;
  setPannelReviewForm: React.Dispatch<React.SetStateAction<IPannelReviewFormData>>;
  asessProductForm: IAsessProductFormData;
  setAsessProductForm: React.Dispatch<React.SetStateAction<IAsessProductFormData>>;
  prePanelInformationForm: IPrePanelInformation[];
  setPrePanelInformationForm: React.Dispatch<React.SetStateAction<IPrePanelInformation[]>>;
  documentApprovalForm: IDocumentApprovalFormData;
  setDocumentApprovalForm: React.Dispatch<React.SetStateAction<IDocumentApprovalFormData>>;
  vendorInformationForms: IVendorInformationFormData[];
  setVendorInformationForms: React.Dispatch<React.SetStateAction<IVendorInformationFormData[]>>;
  newVendorDetailsForm: INewVendorFormData[];
  setNewVendorDetailsForm: React.Dispatch<React.SetStateAction<INewVendorFormData[]>>;
  addProductToVendor: (vendorIndex: number, product: INewProductFormData) => void;
  nutritionForm: INutritionForm;
  setNutritionForm: React.Dispatch<React.SetStateAction<INutritionForm>>;
  nutritionValidationErrors: boolean;
  setNutritionValidationErrors: React.Dispatch<React.SetStateAction<boolean>>;
  nutritionFormErrors: string[];
  setNutritionFormErrors: React.Dispatch<React.SetStateAction<string[]>>;
  nutritionSections: GetNutritionSectionsResponse | null;
  setNutritionSections: React.Dispatch<React.SetStateAction<GetNutritionSectionsResponse | null>>;
  nutritionSectionsTracking: INutritionSectionTrackingItem[];
  setNutritionSectionsTracking: React.Dispatch<React.SetStateAction<INutritionSectionTrackingItem[]>>;
  storageSections: GetStorageSectionsResponse | null;
  setStorageSections: React.Dispatch<React.SetStateAction<GetStorageSectionsResponse | null>>;
  storageSectionsTracking: IStorageSectionTrackingItem[];
  setStorageSectionsTracking: React.Dispatch<React.SetStateAction<IStorageSectionTrackingItem[]>>;

  generalInformationForm : IGeneralInformation;
  setGeneralInformationForm: React.Dispatch<React.SetStateAction<IGeneralInformation>>;
  responsibleUsersForm: IResponsibleUsers;
  setResponsibleUsersForm: React.Dispatch<React.SetStateAction<IResponsibleUsers>>;
  packageAndBrandingForm: IPackageAndBranding;
  setPackageAndBrandingForm: React.Dispatch<React.SetStateAction<IPackageAndBranding>>;
  voteResultsForms: IVoteResults[];
  setVoteResultsForms: React.Dispatch<React.SetStateAction<IVoteResults[]>>;
  competitorInformationForms: ICompetitorInformation[];
  setCompetitorInformationForms: React.Dispatch<React.SetStateAction<ICompetitorInformation[]>>;
  packagingForm: IPackagingFormData;
  setPackagingForm: React.Dispatch<React.SetStateAction<IPackagingFormData>>;
  newProductInformationForm: IProductInformationFormData;
  setNewProductInformationForm: React.Dispatch<React.SetStateAction<IProductInformationFormData>>;
  productInformationForm: ResponseData;
  setProductInformationForm: React.Dispatch<React.SetStateAction<ResponseData>>;
  primaryDatatableInformationForm: VendorResponseData;
  setPrimaryDatatableInformationForm: React.Dispatch<React.SetStateAction<VendorResponseData>>;
  prePanelDatatableInformationForm: PrepanelResponseData;
  setPrePanelDatatableInformationForm: React.Dispatch<React.SetStateAction<PrepanelResponseData>>;
  setVendorAssessmentForm: React.Dispatch<React.SetStateAction<IVendorAssessmentFormData>>;
  vendorAssessmentForm: IVendorAssessmentFormData;
  ingredientDetailsForm: IIngredientDetailsFormData;
  setIngredientDetailsForm: React.Dispatch<React.SetStateAction<IIngredientDetailsFormData>>;
  vendorContactInformationForm: IVendorContactInformationFormData;
  setVendorContactInformationForm: React.Dispatch<React.SetStateAction<IVendorContactInformationFormData>>;
  mainDetailsForm: IMainDetailsForm;
  setMainDetailsForm:   React.Dispatch<React.SetStateAction<IMainDetailsForm>>;
  updateMainDetailsSection: <T extends keyof IMainDetailsForm>(section: T, data: Partial<IMainDetailsForm[T]>) => void;
  updateProductSpecificationInformation: (data: Partial<IProductSpecificationInformationForm>) => void;
  updateProductRelatedInformation: (data: Partial<IProductRelatedInformationForm>) => void;
  updateVendorRelatedInformation: (data: Partial<IVendorRelatedInformation>) => void;
  updateVendorFacilityInformation: (data: Partial<IVendorFacilityInformation>, index?: number) => void;
  photosofItemInRetailPackaging: IPhotosofItemInRetailPackaging;
  setPhotosofItemInRetailPackaging: React.Dispatch<React.SetStateAction<IPhotosofItemInRetailPackaging>>;
  mainDetailsApiData: any;
  setMainDetailsApiData: React.Dispatch<React.SetStateAction<any>>;
  updateMainDetailsApiData: (updates: any) => void;
  foodSafetyPlan: IRequiredDocumentData;
  setFoodSafetyPlan: React.Dispatch<React.SetStateAction<IRequiredDocumentData>>;
  otherDocuments: IRequiredDocumentData;
  setOtherDocuments: React.Dispatch<React.SetStateAction<IRequiredDocumentData>>;
  packProductForm: IPackProductFormData;
  setPackProductForm: React.Dispatch<React.SetStateAction<IPackProductFormData>>;

  manufacturingFacilityInformationForms: IManufacturingFacilityInformationFormData[];
  setManufacturingFacilityInformationForms: React.Dispatch<React.SetStateAction<IManufacturingFacilityInformationFormData[]>>;
  purchaseOrderInformationForm: IPurchaseOrderInformationFormData;
  setPurchaseOrderInformationForm: React.Dispatch<React.SetStateAction<IPurchaseOrderInformationFormData>>;
  vendorInformationFormErrors: VendorInformationFormErrors[];
  setVendorInformationFormErrors: React.Dispatch<React.SetStateAction<VendorInformationFormErrors[]>>;
  productIdeaData: IdeaData;
  setProductIdeaData: React.Dispatch<React.SetStateAction<IdeaData>>;
  productInformatonFormErrors: productInformationFormErrors;
  setProductInformationFormErrors: React.Dispatch<React.SetStateAction<productInformationFormErrors>>;
  selectedIdea: SelectedIdea;
  setSelectedIdea: React.Dispatch<React.SetStateAction<SelectedIdea>>;
  statusesOfProduct: Statuses;
  setStatusesOfProduct: React.Dispatch<React.SetStateAction<Statuses>>;
  statusesOfVendor: vendorStatuses[];
  setStatusesOfVendor: React.Dispatch<React.SetStateAction<vendorStatuses[]>>;
  buttonVisibility: ButtonToVisible;
  setButtonVisibility: React.Dispatch<React.SetStateAction<ButtonToVisible>>;
  buttonVendorAssessmentVisibility: VendorAssessmentButtonToVisible;
  setButtonVendorAssessmentVisibility: React.Dispatch<React.SetStateAction<VendorAssessmentButtonToVisible>>;
  buttonPrePanelVisibility: PrePanelButtonToVisible;
  setButtonPrePanelVisibility: React.Dispatch<React.SetStateAction<PrePanelButtonToVisible>>;
  buttonBusinessReviewVisibility: BusinessReviewButtonToVisible;
  setButtonBusinessReviewVisibility: React.Dispatch<React.SetStateAction<BusinessReviewButtonToVisible>>;
  buttonTastingPanelVisibility: TastingPanelButtonToVisible;
  setButtonTastingPanelVisibility: React.Dispatch<React.SetStateAction<TastingPanelButtonToVisible>>;
  buttonAPComplianceDocumentsVisibility: APComplianceDocumentsButtonToVisible;
  setButtonAPComplianceDocumentsVisibility: React.Dispatch<React.SetStateAction<APComplianceDocumentsButtonToVisible>>;
  buttonAPMainDetailsVisibility: APMainDetailsButtonToVisible;
  setButtonAPMainDetailsVisibility: React.Dispatch<React.SetStateAction<APMainDetailsButtonToVisible>>;
  buttonAPPackagingVisibility: APPackagingButtonToVisible;
  setButtonAPPackagingVisibility: React.Dispatch<React.SetStateAction<APPackagingButtonToVisible>>;
  buttonAPRecipeVisibility: APRecipeButtonToVisible;
  setButtonAPRecipeVisibility: React.Dispatch<React.SetStateAction<APRecipeButtonToVisible>>;
  buttonAPRawMaterialsVisibility: APRawMaterialsButtonToVisible;
  setButtonAPRawMaterialsVisibility: React.Dispatch<React.SetStateAction<APRawMaterialsButtonToVisible>>;
  buttonAPAllergensVisibility: APAllergensButtonToVisible;
  setButtonAPAllergensVisibility: React.Dispatch<React.SetStateAction<APAllergensButtonToVisible>>;
  buttonAPNutritionVisibility: APNutritionButtonToVisible;
  setButtonAPNutritionVisibility: React.Dispatch<React.SetStateAction<APNutritionButtonToVisible>>;
  buttonAPNutritionDeclarationVisibility: APNutritionDeclarationButtonToVisible;
  setButtonAPNutritionDeclarationVisibility: React.Dispatch<React.SetStateAction<APNutritionDeclarationButtonToVisible>>;
  buttonAPStorageVisibility: APStorageButtonToVisible;
  setButtonAPStorageVisibility: React.Dispatch<React.SetStateAction<APStorageButtonToVisible>>;
  requiredDocuments: IRequiredDocumentData;
  setRequiredDocuments: React.Dispatch<React.SetStateAction<IRequiredDocumentData>>;
  vendorAssessmentFormErrors: VendorAssessmentFormErrors;
  setVendorAssessmentFormErrors: React.Dispatch<React.SetStateAction<VendorAssessmentFormErrors>>;
  isVendorAssessmentSubmitClicked: boolean;
  setIsVendorAssessmentSubmitClicked: ( isVendorAssessmentSubmitClicked: boolean ) => void;
  ingredientDetailsFormErrors: IngredientDetailsFormErrors;
  setIngredientDetailsFormErrors: React.Dispatch<React.SetStateAction<IngredientDetailsFormErrors>>;
  vendorContactInformationFormErrors: VendorContactFormErrors;
  setVendorContactInformationFormErrors: React.Dispatch<React.SetStateAction<VendorContactFormErrors>>;
  manufacturingFacilityInformationFormErrors: ManufacturingFacilityInformationFormErrors[];
  setManufacturingFacilityInformationFormErrors: React.Dispatch<React.SetStateAction<ManufacturingFacilityInformationFormErrors[]>>;
  certificatesDocumentsVendorInfoForm: ICertificatesDocumentsVendorInfoFormData;
  setCertificatesDocumentsVendorInfoForm: React.Dispatch<React.SetStateAction<ICertificatesDocumentsVendorInfoFormData>>;
  requiredMvaDocument: IMVADocumentResponse;
  setRequiredMvaDocument: React.Dispatch<React.SetStateAction<IMVADocumentResponse>>;
  retailSalesAndVolume: IRetailSalesAndVolume;
  setRetailSalesAndVolume: React.Dispatch<React.SetStateAction<IRetailSalesAndVolume>>;
  setAddNewVendorUserForm: React.Dispatch<React.SetStateAction<IAddNewVendorUserData>>;
  addNewVendorUserForm: IAddNewVendorUserData;
  vendorPrePanelInformationForm: VendorPrePanelInformationFormData;
  setVendorPrePanelInformationForm: React.Dispatch<React.SetStateAction<VendorPrePanelInformationFormData>>;
  vendorCompanyInformationForm: IVendorCompanyInformationFormData;
  setVendorCompanyInformationForm: React.Dispatch<React.SetStateAction<IVendorCompanyInformationFormData>>;
  foodSafetyQuestionnaireForm: FoodSafetyQuestionnaireFormData;
  setFoodSafetyQuestionnaireForm: React.Dispatch<React.SetStateAction<FoodSafetyQuestionnaireFormData>>;
  vendorSetupForm: IVendorSetupFormData;
  setVendorSetupForm: React.Dispatch<React.SetStateAction<IVendorSetupFormData>>;
  officialProductSetupForm: IOfficialProductSetupFormData;
  setOfficialProductSetupForm: React.Dispatch<React.SetStateAction<IOfficialProductSetupFormData>>;
  statusesOfVendorObj: vendorStatusesObj;
  setStatusesOfVendorObj: React.Dispatch<React.SetStateAction<vendorStatusesObj>>;
  businessQuestionnaireData: BusinessQuestionnairesItem[];
  setBusinessQuestionnaireData: React.Dispatch<React.SetStateAction<BusinessQuestionnairesItem[]>>;
  questionnaireCollection: BusinessQuestionnairesItem[];
  setQuestionnaireCollection: React.Dispatch<React.SetStateAction<BusinessQuestionnairesItem[]>>;
  prePanelGetData: IPrePanelGetData;
  setPrePanelGetData: React.Dispatch<React.SetStateAction<IPrePanelGetData>>;
  prepanelInformation: IPrePanelInformation;
  setPrepanelInformation: React.Dispatch<React.SetStateAction<IPrePanelInformation>>;
  tastingPanelGetData: IPrePanelGetData;
  setTastingPanelGetData: React.Dispatch<React.SetStateAction<IPrePanelGetData>>;
  tastingPanelInformation: IPrePanelInformation;
  setTastingPanelInformation: React.Dispatch<React.SetStateAction<IPrePanelInformation>>;
  businessReviewPanelGetData: IPrePanelGetData;
  setBusinessReviewPanelGetData: React.Dispatch<React.SetStateAction<IPrePanelGetData>>;
  businessReviewPanelInformation: IPrePanelInformation;
  setBusinessReviewPanelInformation: React.Dispatch<React.SetStateAction<IPrePanelInformation>>;
  businessReviewErrors: BusinessReviewFormErrors;
  setBusinessReviewErrors: React.Dispatch<React.SetStateAction<BusinessReviewFormErrors>>;
  businessReviewNewQuestionError: { newQuestion: string; newAnswer: string };
  setBusinessReviewNewQuestionError: React.Dispatch<
    React.SetStateAction<{ newQuestion: string; newAnswer: string }>
  >;
  prePanelErrors:IPrePanelInformationErrors;
  setPrePanelErrors:React.Dispatch<React.SetStateAction<IPrePanelInformationErrors>>;
  nfp: nfpType;
  setNfp: React.Dispatch<React.SetStateAction<nfpType>>;
  tastingPanelStatusesOfVendorObj: TastingPanelVendorStatusesObj;
  setTastingPanelStatusesOfVendorObj: React.Dispatch<React.SetStateAction<TastingPanelVendorStatusesObj>>;
  addNewVendorUserFormData:IVendorUser[];
  setAddNewVendorUserFormData:React.Dispatch<React.SetStateAction<IVendorUser[]>>;
  addNewVendorUserFormErrors:VendorUserInformationFormErrors[];
  setAddNewVendorUserFormErrors:React.Dispatch<React.SetStateAction<VendorUserInformationFormErrors[]>>;
  isAddNewVendorUserFormSubmitted: boolean;
  setIsAddNewVendorUserFormSubmitted: ( isAddNewVendorUserFormSubmitted: boolean ) => void;
  vendorSiteDetailsForms: VendorSiteDetailsFormData[];
  setVendorSiteDetailsForms: React.Dispatch<React.SetStateAction<VendorSiteDetailsFormData[]>>;
  vendorSiteDetailsFormErrors: VendorSiteDetailsFormErrors[];
  setVendorSiteDetailsFormErrors: React.Dispatch<React.SetStateAction<VendorSiteDetailsFormErrors[]>>;

  setVendorSitesForm: React.Dispatch<React.SetStateAction<IVendorSiteDetailsFormData>>;
  vendorSitesForm: IVendorSiteDetailsFormData;
  vendorSiteDatatableList:VendorSiteListData ;
  setVendorSiteDatatableList: React.Dispatch<React.SetStateAction<VendorSiteListData>>;
  
  vendorAuditDetailsForm: IVendorAuditApiResponse;
  setVendorAuditDetailsForm: React.Dispatch<React.SetStateAction<IVendorAuditApiResponse>>;
  vendorAuditQuestionnairesForm: IVendorAuditQuestionnairesFormData[];
  setVendorAuditQuestionnairesForm: React.Dispatch<React.SetStateAction<IVendorAuditQuestionnairesFormData[]>>;
  vendorAuditDatatableList: VendorAuditData;
  setVendorAuditDatatableList: React.Dispatch<React.SetStateAction<VendorAuditData>>;
  vendorContactData: VendorContactData;
  setVendorContactData: React.Dispatch<React.SetStateAction<VendorContactData>>;
  shoplistOnloadData: ShoplistOnloadResponse | null;
  setShoplistOnloadData: React.Dispatch<React.SetStateAction<ShoplistOnloadResponse | null>>;
}

interface ResponseData {
  updatedGroupIdeas: Group[];
  nonGroupIdeas: IShoppingListData[];
  inGroupIdeas: Group[];
  cancelledIdeas: IShoppingListData[];
  onHoldIdeas: IShoppingListData[];
}
export interface Vendors {
  name: string;
  vendors: Vendor[];
  addedOn: string;
  category: string;
  categoryManager: string;
  developer: string;
}
interface Vendor {
  id: string;
  vendorCorporateName: string;
  status: string;
  published: boolean;
}
interface VendorResponseData {
  nonGroupIdeas : Vendors[]
  cancelledIdeas : Vendors[]
}
// Create the context with an initial undefined value
const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider = ({ children }: { children: ReactNode }) => {
  const [pannelReviewForm, setPannelReviewForm] = useState<IPannelReviewFormData>(PannelReviewFormData);
  const [asessProductForm, setAsessProductForm] = useState<IAsessProductFormData>(AsessProductFormData);
  const [prePanelInformationForm, setPrePanelInformationForm] = useState<IPrePanelInformation[]>([]);
  const [documentApprovalForm, setDocumentApprovalForm] = useState<IDocumentApprovalFormData>(DocumentApprovalFormData);
  const [vendorInformationForms, setVendorInformationForms] = useState<IVendorInformationFormData[]>([VendorInformationFormData]);

  const [vendorAssessmentForm, setVendorAssessmentForm] = useState<IVendorAssessmentFormData>(VendorAssessmentFormData);
  const [ingredientDetailsForm, setIngredientDetailsForm] = useState<IIngredientDetailsFormData>(IngredientDetailsFormData);
  const [vendorContactInformationForm, setVendorContactInformationForm] = useState<IVendorContactInformationFormData>(VendorContactInformationFormData);
  const [mainDetailsForm, setMainDetailsForm] = useState<IMainDetailsForm>(MainDetailsFormInitial);

  // Generalized function for updating any MainDetails form section
  const updateMainDetailsSection = useCallback(<T extends keyof IMainDetailsForm>(
    section: T,
    data: Partial<IMainDetailsForm[T]>
  ) => {
    setMainDetailsForm(prev => ({
      ...prev,
      [section]: { ...prev[section], ...data }
    }));
  }, []);

  // Individual helper functions for backward compatibility and type safety
  const updateProductSpecificationInformation = useCallback((data: Partial<IProductSpecificationInformationForm>) => {
    updateMainDetailsSection('productSpecificationInformation', data);
  }, [updateMainDetailsSection]);

  const updateProductRelatedInformation = useCallback((data: Partial<IProductRelatedInformationForm>) => {
    updateMainDetailsSection('productRelatedInformation', data);
  }, [updateMainDetailsSection]);

  const updateVendorRelatedInformation = useCallback((data: Partial<IVendorRelatedInformation>) => {
    updateMainDetailsSection('vendorRelatedInformation', data);
  }, [updateMainDetailsSection]);

  const updateVendorFacilityInformation = useCallback((data: Partial<IVendorFacilityInformation>, index: number = 0) => {
    setMainDetailsForm(prev => {
      const facilities = Array.isArray(prev.vendorFacilityInformation) ? [...prev.vendorFacilityInformation] : [];
      
      // Ensure the array has enough elements
      while (facilities.length <= index) {
        facilities.push({
          siteName: '',
          address1: '',
          city: '',
          state: '',
          country: '',
          zipCodePostalCode: ''
        });
      }
      
      // Update the specific index
      const currentFacility = facilities?.[index] ?? {
        siteName: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        zipCodePostalCode: ''
      };
      facilities[index] = { ...currentFacility, ...data };
      
      return {
        ...prev,
        vendorFacilityInformation: facilities
      };
    });
  }, []);


  
  const [photosofItemInRetailPackaging,setPhotosofItemInRetailPackaging] = useState<IPhotosofItemInRetailPackaging>({});
  const [mainDetailsApiData, setMainDetailsApiData] = useState<any>(null);
  
  // Helper function to update API data
  const updateMainDetailsApiData = useCallback((updates: any) => {
    setMainDetailsApiData((prev: any) => ({
      ...prev,
      ...updates
    }));
  }, []);
  
  const [foodSafetyPlan,setFoodSafetyPlan] = useState<IRequiredDocumentData>(DefaultRequiredDocumentData);
  const [otherDocuments,setOtherDocuments] = useState<IRequiredDocumentData>(DefaultRequiredDocumentData);
  const [packProductForm,setPackProductForm] = useState<IPackProductFormData>(packProductFormData);
  

  const [manufacturingFacilityInformationForms, setManufacturingFacilityInformationForms] = useState<IManufacturingFacilityInformationFormData[]>(DefaultManufacturingFacilityInformationFormsData);
  const [purchaseOrderInformationForm, setPurchaseOrderInformationForm] = useState<IPurchaseOrderInformationFormData>(PurchaseOrderInformationFormData);
  const [generalInformationForm, setGeneralInformationForm] = useState<IGeneralInformation>(GeneralInformationInitial);
  const [responsibleUsersForm, setResponsibleUsersForm] = useState<IResponsibleUsers>(ResponsibleUsersInitial);
  const [retailSalesAndVolume, setRetailSalesAndVolume] = useState<IRetailSalesAndVolume>(RetailSalesAndVolumeInitial);
  const [packageAndBrandingForm, setPackageAndBrandingForm] = useState<IPackageAndBranding>(PackageAndBrandingInitial);
  const [voteResultsForms, setVoteResultsForms] = useState<IVoteResults[]>([VoteResultsInitial]);
  const [competitorInformationForms, setCompetitorInformationForms] = useState<ICompetitorInformation[]>([CompetitorInformationInitial]);

  const [newVendorDetailsForm, setNewVendorDetailsForm] = useState<INewVendorFormData[]>([{ ...NewVendorDetailsForm }]);
  const [packagingForm, setPackagingForm] = useState<IPackagingFormData>(PackagingFormData);
  const [newProductInformationForm, setNewProductInformationForm] = useState<IProductInformationFormData>(NewProductInformationFormData);
  const [productInformationForm, setProductInformationForm] = useState<ResponseData>({
    updatedGroupIdeas: [],
    nonGroupIdeas: [],
    inGroupIdeas: [],
    cancelledIdeas: [],
    onHoldIdeas: []
  })
  const [primaryDatatableInformationForm, setPrimaryDatatableInformationForm] = useState<VendorResponseData>({
    nonGroupIdeas: [],
    cancelledIdeas: [],
  })
  const [prePanelDatatableInformationForm, setPrePanelDatatableInformationForm] = useState<PrepanelResponseData>({
    activeIdeas: [],
    archivedIdeas: [],
    onHoldIdeas: []
  })
  const [productIdeaData, setProductIdeaData] = useState<IdeaData>(ProductIdeaData);
  const [selectedIdea, setSelectedIdea] = useState<SelectedIdea>(SelectedIdeaInfo);
  const [statusesOfProduct, setStatusesOfProduct] = useState<Statuses>(DefaultStatusesOfProduct);
  const [statusesOfVendor, setStatusesOfVendor] = useState<vendorStatuses[]>([]);
  const [statusesOfVendorObj, setStatusesOfVendorObj] = useState<vendorStatusesObj>(defaultVendorStatusesObj);
  const [buttonVisibility, setButtonVisibility] = useState<ButtonToVisible>(DefaultButtonVisibility);
  const [buttonVendorAssessmentVisibility, setButtonVendorAssessmentVisibility] = useState<VendorAssessmentButtonToVisible>(DefaultVendorAssessmentButtonVisibility);
  const [buttonPrePanelVisibility, setButtonPrePanelVisibility] = useState<PrePanelButtonToVisible>(DefaultPrePanelButtonVisibility);
  const [buttonBusinessReviewVisibility, setButtonBusinessReviewVisibility] = useState<BusinessReviewButtonToVisible>(DefaultBusinessReviewButtonVisibility);
  const [buttonTastingPanelVisibility, setButtonTastingPanelVisibility] = useState<TastingPanelButtonToVisible>(DefaultTastingPanelButtonVisibility);
  const [vendorPrePanelInformationForm, setVendorPrePanelInformationForm] = useState<VendorPrePanelInformationFormData>(vendorPrePanelInformationFormData);
  const [vendorCompanyInformationForm, setVendorCompanyInformationForm] = useState<IVendorCompanyInformationFormData>(DefaultVendorCompanyInformationFormData);
  const [foodSafetyQuestionnaireForm, setFoodSafetyQuestionnaireForm] = useState<FoodSafetyQuestionnaireFormData>(foodSafetyQuestionnaireFormData);
  const [buttonAPComplianceDocumentsVisibility, setButtonAPComplianceDocumentsVisibility] = useState<APComplianceDocumentsButtonToVisible>(DefaultAPComplianceDocumentsButtonVisibility);
  const [buttonAPMainDetailsVisibility, setButtonAPMainDetailsVisibility] = useState<APMainDetailsButtonToVisible>(DefaultAPMainDetailsButtonVisibility);
  const [buttonAPPackagingVisibility, setButtonAPPackagingVisibility] = useState<APPackagingButtonToVisible>(DefaultAPPackagingButtonVisibility);
  const [buttonAPRecipeVisibility, setButtonAPRecipeVisibility] = useState<APRecipeButtonToVisible>(DefaultAPRecipeButtonVisibility);
  const [buttonAPRawMaterialsVisibility, setButtonAPRawMaterialsVisibility] = useState<APRawMaterialsButtonToVisible>(DefaultAPRawMaterialsButtonVisibility);
  const [buttonAPAllergensVisibility, setButtonAPAllergensVisibility] = useState<APAllergensButtonToVisible>(DefaultAPAllergensButtonVisibility);
  const [buttonAPNutritionVisibility, setButtonAPNutritionVisibility] = useState<APNutritionButtonToVisible>(DefaultAPNutritionButtonVisibility);
  const [buttonAPNutritionDeclarationVisibility, setButtonAPNutritionDeclarationVisibility] = useState<APNutritionDeclarationButtonToVisible>(DefaultAPNutritionDeclarationButtonVisibility);
  const [buttonAPStorageVisibility, setButtonAPStorageVisibility] = useState<APStorageButtonToVisible>(DefaultAPStorageButtonVisibility);
  const [prePanelGetData, setPrePanelGetData] = useState<IPrePanelGetData>({} as IPrePanelGetData);
  const [businessQuestionnaireData, setBusinessQuestionnaireData] = useState<BusinessQuestionnairesItem[]>([]);
  const [prepanelInformation, setPrepanelInformation] = useState<IPrePanelInformation>(DefaultPrepanelInformationFormData);
  const [questionnaireCollection, setQuestionnaireCollection] = useState<BusinessQuestionnairesItem[]>([]);

  const [tastingPanelGetData, setTastingPanelGetData] = useState<IPrePanelGetData>({} as IPrePanelGetData);
  const [tastingPanelInformation, setTastingPanelInformation] = useState<IPrePanelInformation>(DefaultPrepanelInformationFormData);
  const [businessReviewPanelGetData, setBusinessReviewPanelGetData] = useState<IPrePanelGetData>({} as IPrePanelGetData);
  const [businessReviewPanelInformation, setBusinessReviewPanelInformation] = useState<IPrePanelInformation>(DefaultPrepanelInformationFormData);
  const [businessReviewErrors, setBusinessReviewErrors] = useState<BusinessReviewFormErrors>({});
  const [businessReviewNewQuestionError, setBusinessReviewNewQuestionError] = useState<{
    newQuestion: string;
    newAnswer: string;
  }>({ newQuestion: "", newAnswer: "" });

  const addProductToVendor = (vendorIndex: number, product: INewProductFormData) => {
    setNewVendorDetailsForm((prevVendors) => {
      const updatedVendors = [...prevVendors];
      const currentVendor = updatedVendors?.[vendorIndex];
      if (!currentVendor) return prevVendors;
      currentVendor.products = [...currentVendor.products, product];
      return updatedVendors;
    });
  };

  const [vendorInformationFormErrors, setVendorInformationFormErrors] = useState<VendorInformationFormErrors[]>([]);
  const [productInformatonFormErrors, setProductInformationFormErrors] = useState<productInformationFormErrors>({});
  const [requiredDocuments, setRequiredDocuments] = useState<IRequiredDocumentData>(DefaultRequiredDocumentData);
  const [vendorAssessmentFormErrors, setVendorAssessmentFormErrors] = useState<VendorAssessmentFormErrors>([]);
  const [ingredientDetailsFormErrors, setIngredientDetailsFormErrors] = useState<IngredientDetailsFormErrors>({});
  const [vendorContactInformationFormErrors, setVendorContactInformationFormErrors] = useState<VendorContactFormErrors>([]);
  const [manufacturingFacilityInformationFormErrors, setManufacturingFacilityInformationFormErrors] = useState<ManufacturingFacilityInformationFormErrors[]>([]);
  const [isVendorAssessmentSubmitClicked, setIsVendorAssessmentSubmitClicked] = useState<boolean>(false);
  const [nutritionForm, setNutritionForm] = useState<INutritionForm>(NutritionFormInitial);
  const [nutritionValidationErrors, setNutritionValidationErrors] = useState<boolean>(false);
  const [nutritionFormErrors, setNutritionFormErrors] = useState<string[]>([]);
  const [nutritionSections, setNutritionSections] = useState<GetNutritionSectionsResponse | null>(null);
  const [nutritionSectionsTracking, setNutritionSectionsTracking] = useState<INutritionSectionTrackingItem[]>([]);
  const [storageSections, setStorageSections] = useState<GetStorageSectionsResponse | null>(null);
  const [storageSectionsTracking, setStorageSectionsTracking] = useState<IStorageSectionTrackingItem[]>([]);

  const [certificatesDocumentsVendorInfoForm, setCertificatesDocumentsVendorInfoForm] = useState<ICertificatesDocumentsVendorInfoFormData>(CertificatesDocumentsVendorInfoFormData);
  const [requiredMvaDocument, setRequiredMvaDocument] = useState<IMVADocumentResponse>(DefaultMVADocumentResponse);
  const [addNewVendorUserForm, setAddNewVendorUserForm] = useState<IAddNewVendorUserData>(addNewVendorUserData);
  const [vendorSetupForm, setVendorSetupForm] = useState<IVendorSetupFormData>(VendorSetupFormData);  
  const [officialProductSetupForm, setOfficialProductSetupForm] = useState<IOfficialProductSetupFormData>(officialProductSetupFormData);
  const [prePanelErrors, setPrePanelErrors] = useState<IPrePanelInformationErrors>({});
  const [nfp, setNfp] = useState<nfpType>({});
  const [vendorAuditDetailsForm, setVendorAuditDetailsForm] = useState<IVendorAuditApiResponse>(initializeVendorAuditDetailsForm({} as IVendorAuditApiResponse));
  const [vendorAuditQuestionnairesForm, setVendorAuditQuestionnairesForm] = useState<IVendorAuditQuestionnairesFormData[]>([]);
  const [vendorAuditDatatableList, setVendorAuditDatatableList] = useState<VendorAuditData>([]);
  const [tastingPanelStatusesOfVendorObj, setTastingPanelStatusesOfVendorObj] = useState<TastingPanelVendorStatusesObj>(defaultTastigPanelVendorStatusObj);
  const [addNewVendorUserFormData, setAddNewVendorUserFormData] = useState<IVendorUser[]>(InitialAddNewVendorFormsData);
  const [addNewVendorUserFormErrors, setAddNewVendorUserFormErrors] = useState<VendorUserInformationFormErrors[]>([]);
  const [isAddNewVendorUserFormSubmitted, setIsAddNewVendorUserFormSubmitted] = useState<boolean>(false);
  const [vendorSiteDetailsForms, setVendorSiteDetailsForms] = useState<VendorSiteDetailsFormData[]>(DefaultVendorSiteDetailsFormsData);
  const [vendorSiteDetailsFormErrors, setVendorSiteDetailsFormErrors] = useState<VendorSiteDetailsFormErrors[]>([]);

  const [vendorSitesForm, setVendorSitesForm] = useState<IVendorSiteDetailsFormData>(vendorSitesFormData);
  const [vendorSiteDatatableList, setVendorSiteDatatableList] = useState<VendorSiteListData>([]);
  const [vendorContactData, setVendorContactData] = useState<VendorContactData>(DefaultVendorContactData);
  const [shoplistOnloadData, setShoplistOnloadData] = useState<ShoplistOnloadResponse | null>(null);

  // Memoize the provider value to prevent unnecessary rerenders
  const providerValue = useMemo(() => ({
        pannelReviewForm,
        setPannelReviewForm,
        asessProductForm,
        setAsessProductForm,
        prePanelInformationForm,
        setPrePanelInformationForm,
        documentApprovalForm,
        setDocumentApprovalForm,
        vendorInformationForms,
        setVendorInformationForms,
        productInformationForm,
        setProductInformationForm,
        newVendorDetailsForm,
        setNewVendorDetailsForm,
        addProductToVendor,
        nutritionForm,
        setNutritionForm,
        nutritionValidationErrors,
        setNutritionValidationErrors,
        nutritionFormErrors,
        setNutritionFormErrors,
        nutritionSections,
        setNutritionSections,
        nutritionSectionsTracking,
        setNutritionSectionsTracking,
        storageSections,
        setStorageSections,
        storageSectionsTracking,
        setStorageSectionsTracking,

        packagingForm,
        setPackagingForm,
        newProductInformationForm,
        setNewProductInformationForm,
        vendorAssessmentForm,
        setVendorAssessmentForm,
        ingredientDetailsForm,
        setIngredientDetailsForm,
        vendorContactInformationForm,
        setVendorContactInformationForm,
        manufacturingFacilityInformationForms,
        setManufacturingFacilityInformationForms,
        purchaseOrderInformationForm,
        setPurchaseOrderInformationForm,
        vendorInformationFormErrors,
        setVendorInformationFormErrors,
        productIdeaData, // New context value
        setProductIdeaData,
        selectedIdea,
        setSelectedIdea,
        productInformatonFormErrors,
        setProductInformationFormErrors,
        statusesOfProduct,
        setStatusesOfProduct,
        statusesOfVendor,
        setStatusesOfVendor,
        buttonVisibility,
        setButtonVisibility,
        buttonVendorAssessmentVisibility,
        setButtonVendorAssessmentVisibility,
        buttonPrePanelVisibility,
        setButtonPrePanelVisibility,
        buttonBusinessReviewVisibility,
        setButtonBusinessReviewVisibility,
        buttonAPComplianceDocumentsVisibility,
        setButtonAPComplianceDocumentsVisibility,
        buttonAPMainDetailsVisibility,
        setButtonAPMainDetailsVisibility,
        buttonAPPackagingVisibility,
        setButtonAPPackagingVisibility,
        buttonAPRecipeVisibility,
        setButtonAPRecipeVisibility,
        buttonAPRawMaterialsVisibility,
        setButtonAPRawMaterialsVisibility,
        buttonAPAllergensVisibility,
        setButtonAPAllergensVisibility,
        buttonAPNutritionVisibility,
        setButtonAPNutritionVisibility,
        buttonAPNutritionDeclarationVisibility,
        setButtonAPNutritionDeclarationVisibility,
        buttonAPStorageVisibility,
        setButtonAPStorageVisibility,
        buttonTastingPanelVisibility,
        setButtonTastingPanelVisibility,
        requiredDocuments,
        setRequiredDocuments,
        vendorAssessmentFormErrors,
        setVendorAssessmentFormErrors,
        isVendorAssessmentSubmitClicked,
        setIsVendorAssessmentSubmitClicked,
        ingredientDetailsFormErrors,
        setIngredientDetailsFormErrors,
        vendorContactInformationFormErrors,
        setVendorContactInformationFormErrors,
        manufacturingFacilityInformationFormErrors,
        setManufacturingFacilityInformationFormErrors,
        primaryDatatableInformationForm,
        setPrimaryDatatableInformationForm,
        prePanelDatatableInformationForm,
        setPrePanelDatatableInformationForm,
        mainDetailsForm,
        setMainDetailsForm,
        updateMainDetailsSection,
        updateProductSpecificationInformation,
        updateProductRelatedInformation,
        updateVendorRelatedInformation,
        updateVendorFacilityInformation,
        photosofItemInRetailPackaging,
        setPhotosofItemInRetailPackaging,
        mainDetailsApiData,
        setMainDetailsApiData,
        updateMainDetailsApiData,
        foodSafetyPlan,
        setFoodSafetyPlan,
        otherDocuments,
        setOtherDocuments,
        packProductForm,
        setPackProductForm,

        certificatesDocumentsVendorInfoForm,
        setCertificatesDocumentsVendorInfoForm,
        requiredMvaDocument,
        setRequiredMvaDocument,
        generalInformationForm,
        setGeneralInformationForm,
        responsibleUsersForm,
        setResponsibleUsersForm,
        retailSalesAndVolume,
        setRetailSalesAndVolume,
        packageAndBrandingForm,
        setPackageAndBrandingForm,
        voteResultsForms,
        setVoteResultsForms,
        competitorInformationForms,
        setCompetitorInformationForms,
        addNewVendorUserForm,
        setAddNewVendorUserForm,
        vendorPrePanelInformationForm,
        setVendorPrePanelInformationForm,
        vendorCompanyInformationForm,
        setVendorCompanyInformationForm,
        foodSafetyQuestionnaireForm,
        setFoodSafetyQuestionnaireForm,
        vendorSetupForm,
        setVendorSetupForm,
        officialProductSetupForm,
        setOfficialProductSetupForm,
        vendorAuditDetailsForm,
        setVendorAuditDetailsForm,
        vendorSitesForm,
        setVendorSitesForm,
        vendorSiteDatatableList,
        setVendorSiteDatatableList,
        statusesOfVendorObj,
        setStatusesOfVendorObj,
        prePanelGetData,
        setPrePanelGetData,
        businessQuestionnaireData,
        setBusinessQuestionnaireData,
        prepanelInformation,
        setPrepanelInformation,
        questionnaireCollection,
        setQuestionnaireCollection,
        tastingPanelGetData,
        setTastingPanelGetData,
        tastingPanelInformation,        
        setTastingPanelInformation,
        businessReviewPanelGetData,
        setBusinessReviewPanelGetData,
        businessReviewPanelInformation,
        setBusinessReviewPanelInformation,
        businessReviewErrors,
        setBusinessReviewErrors,
        businessReviewNewQuestionError,
        setBusinessReviewNewQuestionError,
        prePanelErrors,
        setPrePanelErrors,
        nfp,
        setNfp,
        tastingPanelStatusesOfVendorObj,
        setTastingPanelStatusesOfVendorObj,
        addNewVendorUserFormData,
        setAddNewVendorUserFormData,
        addNewVendorUserFormErrors, 
        setAddNewVendorUserFormErrors,
        isAddNewVendorUserFormSubmitted,
        setIsAddNewVendorUserFormSubmitted,
        vendorSiteDetailsForms,
        setVendorSiteDetailsForms,
        vendorSiteDetailsFormErrors,
        setVendorSiteDetailsFormErrors,
        vendorAuditQuestionnairesForm,
        setVendorAuditQuestionnairesForm,
        vendorAuditDatatableList,
        setVendorAuditDatatableList,
        vendorContactData,
        setVendorContactData,
        shoplistOnloadData,
        setShoplistOnloadData,
      }), [
        // Memoization dependencies - include all state values and memoized functions
        pannelReviewForm, asessProductForm, prePanelInformationForm, documentApprovalForm, vendorInformationForms,
        productInformationForm, newVendorDetailsForm, nutritionForm, nutritionValidationErrors, nutritionFormErrors, nutritionSections, nutritionSectionsTracking, storageSections, storageSectionsTracking, packagingForm, 
        newProductInformationForm, vendorAssessmentForm, ingredientDetailsForm, vendorContactInformationForm,
        mainDetailsForm, updateMainDetailsSection, updateProductSpecificationInformation, updateProductRelatedInformation,
        updateVendorRelatedInformation, updateVendorFacilityInformation, manufacturingFacilityInformationForms,
        purchaseOrderInformationForm, vendorInformationFormErrors, productIdeaData, selectedIdea,
        productInformatonFormErrors, statusesOfProduct, statusesOfVendor, buttonVisibility,
        buttonVendorAssessmentVisibility, buttonPrePanelVisibility, buttonBusinessReviewVisibility, 
        buttonAPComplianceDocumentsVisibility, buttonAPMainDetailsVisibility, buttonAPPackagingVisibility,
        buttonAPRecipeVisibility, buttonAPRawMaterialsVisibility, buttonAPAllergensVisibility,
        buttonAPNutritionVisibility, buttonAPNutritionDeclarationVisibility, buttonAPStorageVisibility,
        buttonTastingPanelVisibility,         requiredDocuments, vendorAssessmentFormErrors, isVendorAssessmentSubmitClicked,
        ingredientDetailsFormErrors, vendorContactInformationFormErrors, manufacturingFacilityInformationFormErrors,
        primaryDatatableInformationForm, prePanelDatatableInformationForm, photosofItemInRetailPackaging, setPhotosofItemInRetailPackaging,
        mainDetailsApiData, updateMainDetailsApiData, foodSafetyPlan, otherDocuments, packProductForm, certificatesDocumentsVendorInfoForm, requiredMvaDocument,
        generalInformationForm, responsibleUsersForm, retailSalesAndVolume, packageAndBrandingForm,
        voteResultsForms, competitorInformationForms, addNewVendorUserForm, vendorPrePanelInformationForm,
        vendorCompanyInformationForm, vendorSetupForm, officialProductSetupForm, vendorSitesForm,
        vendorSiteDatatableList, statusesOfVendorObj, prePanelGetData, businessQuestionnaireData,
        prepanelInformation, questionnaireCollection, tastingPanelGetData, tastingPanelInformation,
        businessReviewPanelGetData, businessReviewPanelInformation, businessReviewErrors, businessReviewNewQuestionError, prePanelErrors, nfp,
        tastingPanelStatusesOfVendorObj, addNewVendorUserFormData, addNewVendorUserFormErrors,
        isAddNewVendorUserFormSubmitted, vendorSiteDetailsForms, vendorSiteDetailsFormErrors,
        vendorAuditQuestionnairesForm, vendorAuditDatatableList, vendorAuditDetailsForm, vendorContactData,
        shoplistOnloadData, setShoplistOnloadData,
      ]);

  return (
    <FormContext.Provider value={providerValue}>
      {children}
    </FormContext.Provider>
  );
};

// Custom hook to use the context
export const useFormContext = () => {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
